export default __webpack_public_path__ + "static/media/search.c512e606.svg";